module.exports = __webpack_public_path__ + "static/media/spanish-imperative-table4.2a76deb3.PNG";